import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, MailState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type MailGetter = GetterTree<MailState, RootState>

const state: MailState = {
  /*
  SUJETS
  */
  mailSujets: null,
  mailSujet: null,
  /*
    BLOCS
  */
  mailBlocTexts: null,
  mailBlocText: null,
  /*
    MAIL ADRESSE INTERNE */
  mailAdresseInternes: null
}

export const getters: MailGetter = {
  /*
  SUJETS
  */
  mailSujetsGetter: (state) => state.mailSujets,
  mailSujetGetter: (state) => state.mailSujet,
  /*
    BLOCS
  */
  mailBlocTextsGetter: (state) => state.mailBlocTexts,
  mailBlocTextGetter: (state) => state.mailBlocText,
  /*
    ADRESSE INTERNE
  */
  mailAdresseInternesGetter: (state) => state.mailAdresseInternes
}

export const actions: ActionTree<MailState, RootState> = {
  /*
  SUJETS
  */
  async getMailSujetsAction({commit, state}, queryParams) {
    const {data} = await axios.get(`${apiUrl}/mailSujet`, {
      params: {
        ...queryParams
      }
    })
    commit('getMailSujetsMutation', data)
    return data
  },
  async getMailSujetByIdAction({commit}, id) {
    commit('resetMailSujetMutation')
    const {data} = await axios.get(`${apiUrl}/mailSujet/${id}`)
    commit('getMailSujetByIdMutation', data)
    return data
  },
  async createMailSujetAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/mailSujet`, formParams)
    return data
  },
  async updateMailSujetAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/mailSujet/${id}`, formParams)
    return data
  },
  async deleteMailSujetAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/mailSujet/${id}`)
    return id
  },
  async syncMailSujetAction({commit}, syncData) {
    const {data} = await axios.post(`${apiUrl}/mailSujet/sync`, {data: syncData})
    return data
  },
  /*
    BLOCS
  */
  async getMailBlocTextsAction({commit, state}, queryParams) {
    const {data} = await axios.get(`${apiUrl}/mailBloc`, {
      params: {
        ...queryParams
      }
    })
    commit('getMailBlocTextsMutation', data)
    return data
  },
  async getMailBlocTextByIdAction({commit}, id) {
    commit('resetMailBlocTextMutation')
    const {data} = await axios.get(`${apiUrl}/mailBloc/${id}`)
    commit('getMailBlocTextByIdMutation', data)
    return data
  },
  async createMailBlocTextAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/mailBloc`, formParams)
    return data
  },
  async updateMailBlocTextAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/mailBloc/${id}`, formParams)
    return data
  },
  async deleteMailBlocTextAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/mailBloc/${id}`)
    return id
  },
  async syncMailBlocTextAction({commit}, syncData) {
    const {data} = await axios.post(`${apiUrl}/mailBloc/sync`, {data: syncData})
    return data
  },
  /*
    MAIL ADRESSE INTERNE
  */
  async getMailAdresseInternesAction({commit, state}, queryParams) {
    const {data} = await axios.get(`${apiUrl}/mailAdresseInterne`, {
      params: {
        ...queryParams
      }
    })
    commit('getMailAdresseInternesMutation', data)
    return data
  },
  /* SEND MAIL */
  async sendEmailAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/mail`, formParams)
    return data
  }
}

const mutations: MutationTree<MailState> = {
  /*
  SUJETS
  */
  getMailSujetsMutation(state, data) {
    state.mailSujets = data
  },
  getMailSujetByIdMutation(state, data) {
    state.mailSujet = data
  },
  resetMailSujetMutation(state) {
    state.mailSujet = null
  },
  /*
    BLOCS
  */
  getMailBlocTextsMutation(state, data) {
    state.mailBlocTexts = data
  },
  getMailBlocTextByIdMutation(state, data) {
    state.mailBlocText = data
  },
  resetMailBlocTextMutation(state) {
    state.mailBlocText = null
  },
  /*
    MAIL ADRESSE INTERNE
  */
  getMailAdresseInternesMutation(state, data) {
    state.mailAdresseInternes = data
  }
}

export const mail: Module<MailState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
